import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import ManualNotification from '../../../Api/Models/ManualNotification';
import TrueFalseIcon from '../../../components/common/TrueFalseIcon';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ProtectedLink from '../../elements/ProtectedLink';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator, { UpdateItemsFunction } from '../../hooks/useAutoPaginator';

export default function NotificationList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<ManualNotification>((page, params) =>
        CRMApi.manualNotifications.getAll(page, { params })
    );

    return (
        <>
            <ActionButton
                url="/notifications/create"
                title="Create new Notification"
                permissions={[PERMISSION.CREATE_MANUAL_NOTIFICATION]}
            />
            <Card title="All Manual Notifications">
                <Search {...auto.search} />
                <TableLoader isLoading={isLoading}>
                    <table className="table model-list">
                        <TableHead>
                            <th>Actions</th>
                            <th>ID</th>
                            <th>Admin ID</th>
                            <th>Title</th>
                            <th>Is active</th>
                            <th>Start date</th>
                            <th>Termination</th>
                        </TableHead>
                        <NotificationsTableBody notifications={items} update={updateItems} />
                    </table>
                    <Paginator {...auto.paginator} />
                </TableLoader>
            </Card>
        </>
    );
}

type NotificationsTableBodyProps = { notifications: ManualNotification[]; update: UpdateItemsFunction };

function NotificationsTableBody({ notifications, update }: NotificationsTableBodyProps) {
    return (
        <tbody>
            {notifications.map((notification) => (
                <tr key={notification.id}>
                    <td>
                        <ViewButton
                            url={`/notifications/${notification.id}`}
                            permissions={[PERMISSION.VIEW_MANUAL_NOTIFICATION]}
                        />
                        <EditButton
                            url={`/notifications/${notification.id}/update`}
                            permissions={[PERMISSION.UPDATE_MANUAL_NOTIFICATION]}
                        />
                        <DeleteButton
                            url={`/crea/api/notifications/${notification.id}`}
                            action={update}
                            permissions={[PERMISSION.DELETE_MANUAL_NOTIFICATION]}
                        />
                    </td>
                    <td>{notification.id}</td>
                    <td>
                        <ProtectedLink
                            url={`/admins/${notification.admin_id}`}
                            value={notification.admin_id}
                            permissions={[PERMISSION.VIEW_ADMIN]}
                        />
                    </td>
                    <td>{notification.title}</td>
                    <td>
                        <TrueFalseIcon status={notification.is_active} />
                    </td>
                    <td>{notification.start_date}</td>
                    <td>{notification.end_date || notification.left_to_deliver || 0}</td>
                </tr>
            ))}
        </tbody>
    );
}
